import { useMemo } from 'react'
import { usePlan } from '~/app/plan-context'

interface EventGateInput {
  maxActiveEvents: number
  activeEvents: number
  isLoading: boolean
}

interface EventGate {
  isUnlimited: boolean
  used: number
  max: number
  atLimit: boolean
  canCreate: boolean
  isLoading: boolean
}

function deriveEventGate({ maxActiveEvents, activeEvents, isLoading }: EventGateInput): EventGate {
  const isUnlimited = maxActiveEvents === -1
  const used = activeEvents
  const max = maxActiveEvents

  if (isLoading || (!isUnlimited && max <= 0)) {
    return {
      isUnlimited,
      used,
      max,
      atLimit: false,
      canCreate: true,
      isLoading,
    }
  }

  const atLimit = !isUnlimited && used >= max

  return {
    isUnlimited,
    used,
    max,
    atLimit,
    canCreate: !atLimit,
    isLoading,
  }
}

export function useEventGate(): EventGate {
  const { limits, usage, isLoading } = usePlan()

  return useMemo(
    () =>
      deriveEventGate({
        maxActiveEvents: limits.maxActiveEvents,
        activeEvents: usage.activeEvents,
        isLoading,
      }),
    [limits.maxActiveEvents, usage.activeEvents, isLoading],
  )
}
